import { render } from "./sk-user-popup.vue?vue&type=template&id=128e26f0"
const script = {}

import "./sk-user-popup.vue?vue&type=style&index=0&id=128e26f0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__